import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { Subject } from '../subject';
import { Grade } from '../grade';
import { SectionSummary } from '../section-summary';
import { AudioFile } from '../audio-file';
export var FormRelease = /*#__PURE__*/function (_Entity) {
  _inherits(FormRelease, _Entity);

  var _super = _createSuper(FormRelease);

  function FormRelease() {
    _classCallCheck(this, FormRelease);

    return _super.apply(this, arguments);
  }

  _createClass(FormRelease, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "sections",
    get: function get() {
      return this.props.sections;
    }
  }, {
    key: "coverImage",
    get: function get() {
      return this.props.coverImage;
    }
  }, {
    key: "subjects",
    get: function get() {
      return this.props.subjects;
    }
  }, {
    key: "grades",
    get: function get() {
      return this.props.grades;
    }
  }, {
    key: "tags",
    get: function get() {
      return this.props.tags;
    }
  }, {
    key: "category",
    get: function get() {
      return this.props.category;
    }
  }, {
    key: "version",
    get: function get() {
      return this.props.version;
    }
  }, {
    key: "headings",
    get: function get() {
      return this.props.headings || [];
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      var formRelease = _objectSpread(_objectSpread({}, this.props), {}, {
        sections: this.props.sections.map(function (s) {
          return s.toJsonObject();
        }),
        grades: this.props.grades.map(function (g) {
          return g.toJsonObject();
        }),
        subjects: this.props.subjects.map(function (s) {
          return s.toJsonObject();
        }),
        tags: this.props.tags.map(function (t) {
          return t.toJsonObject();
        })
      });

      return formRelease;
    }
  }, {
    key: "getSectionByIndex",
    value: function getSectionByIndex(sectionIndex) {
      return this.sections[sectionIndex];
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.sections,
        argumentName: 'Sections'
      }, {
        argument: props.coverImage,
        argumentName: 'Cover Image'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      return Result.ok(new FormRelease(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var id = data.id,
            title = data.title,
            description = data.description,
            coverImage = data.coverImage,
            assignmentId = data.assignmentId,
            grades = data.grades,
            sections = data.sections,
            subjects = data.subjects,
            tags = data.tags,
            version = data.version;
        var sectionProps = sections.map(function (s) {
          return SectionSummary.create({
            id: s.id.toString(),
            formId: id,
            title: s.title,
            description: s.description,
            totalQuestion: s.totalQuestion,
            totalScore: s.totalScore,
            index: s.index,
            previousSectionId: s.previousSectionId,
            audioFile: s !== null && s !== void 0 && s.audioFile ? AudioFile.fromJson(s.audioFile).getValue() : undefined
          }).getValue();
        });
        var formProps = {
          id: id,
          title: title,
          description: description,
          coverImage: coverImage,
          assignmentId: assignmentId,
          sections: sectionProps,
          version: version
        };

        if (grades) {
          var gradeProps = grades.map(function (g) {
            return Grade.create({
              id: g.id,
              key: g.key,
              translation: g.translation
            }).getValue();
          });
          formProps.grades = gradeProps;
        }

        if (subjects) {
          var subjectProps = subjects.map(function (s) {
            return Subject.create({
              id: s.id,
              key: s.key,
              translation: s.translation
            }).getValue();
          });
          formProps.subjects = subjectProps;
        }

        return this.create(formProps);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return FormRelease;
}(Entity);